/**
 * @desc app区域组件
 * @time 2023-07-31 15:43:01
 * @user simxin
 */

import { useEffect } from 'react';
import { router } from '@src/utils/router';
import { LoadingStatus, ErrorStatus } from '@src/component/loading';
import { usePortalStore } from '@src/store';

export const LayoutLand = () => {
  const loadedApp = usePortalStore(state => state.loadedApp);
  const errorApp = usePortalStore(state => state.errorApp);

  /**
   * @desc 加载区块后再监听路由，加载对应模块
   */
  useEffect(() => {
    router();
  }, []);

  return (
    <div id="app-area-wrap" className="micro-loading-land">
      {/* app-area 为模块挂载节点 */}
      {/* <div id="app-area"></div> */}
      {!loadedApp && <LoadingStatus />}
      {errorApp && <ErrorStatus />}
    </div>
  );
};
